import PropTypes from 'prop-types';
import React from 'react';
import { Carousel as ReactCarousel } from 'react-bootstrap';
import MediaGalleryImage from '../../../../modules/react/components/stateful/MediaGalleryImage';
import BackgroundSlideshow from '../../../../src/web/components/BackgroundSlideshow/BackgroundSlideshow';
import Icon from '../../../../src/web/components/Icon';
import styles from './styles.scss';

const propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.string,
      filename: PropTypes.string,
      alt: PropTypes.string.isRequired,
      title: PropTypes.string,
    }),
  ),
  isEditingAChild: PropTypes.bool,
  isBuilderView: PropTypes.bool,
};

const defaultProps = {
  isBuilderView: false,
  isEditingAChild: undefined,
  images: [],
};

const Carousel = ({
  isEditingAChild,
  images,
  isBuilderView,
  isSectionBackground,
  slideshowSetting,
}) => {
  if ((!images || !images.length) && isBuilderView) {
    return <span>No images set.</span>;
  }

  if (isSectionBackground) {
    return (
      <div className={styles.slideshow}>
        <BackgroundSlideshow
          images={images}
          slideshowSetting={slideshowSetting}
        />
      </div>
    );
  }

  return (
    <ReactCarousel
      indicators={false}
      controls={isEditingAChild ? false : images.length > 0}
      prevIcon={<Icon icon="back-arrow" />}
      nextIcon={<Icon icon="select-arrow" />}
      className={styles.carousel}
      interval={isEditingAChild ? 0 : undefined}
    >
      {images.map(({ file, alt, title, medium }, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <ReactCarousel.Item key={index} className={styles.item}>
          <MediaGalleryImage
            medium={medium}
            legacyImage={{ file, alt, title }}
          />
        </ReactCarousel.Item>
      ))}
    </ReactCarousel>
  );
};

Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;

export default Carousel;
